<div [formGroup]="filterForm">
    <div class="mb-3 p-3 rounded shadow-sm bg-light-orange">

        <!-- Row 1 -->
        <div class="row align-items-center mb-3">
            
            <!-- Left: Exchange -->
            <div class="col-6 d-flex align-items-center">
                <label class="col-form-label mr-4"><strong>Exchange</strong></label>
                <div class="form-check form-check-inline">
                    <input 
                    class="form-checkbox"
                    type="checkbox"
                    id="exchange-set"
                    value="SET"
                    [checked]="filterForm.value.exchange?.includes('SET')"
                    (change)="onExchangeChange($event)">
                    <label class="form-check-label" for="exchange-set">The Stock Exchange of Thailand</label>
                </div>
                <div class="form-check form-check-inline" *ngIf="eventInfoWithConsent?.isShowSalePersonForInvestorRegistration">
                    <input 
                        class="form-checkbox"
                        type="checkbox"
                        id="exchange-other"
                        value="OTHER"
                        [checked]="filterForm.value.exchange?.includes('OTHER')"
                        (change)="onExchangeChange($event)">
                    <label class="form-check-label" for="exchange-other">ASEAN Exchanges</label>
                </div>
            </div>

            <!-- Right: View -->
            <div class="col-6 d-flex justify-content-end">
                <div class="form-check form-check-inline">
                    <input 
                        class="form-checkbox"
                        type="checkbox"
                        id="view-checkbox"
                        formControlName="viewJumpplus">
                    <label class="form-check-label d-flex align-items-center" for="view-checkbox">
                       <span>View only</span>
                        <img id="jumpplus-img" src="assets/images/jumpplus.png" class="mb-2 ml-1 jumpplus-icon" alt="Jumpplus">
                    </label>
                    
                </div>
            </div>
        </div>

        <!-- Row 2 -->
        <div class="row mb-2">
            
            <div class="col-md-5">
                <label for="search">Search Company</label>
                <div class="search-input-wrapper">
                    <input 
                        id="search"
                        type="text" 
                        class="form-control search-input" 
                        placeholder="Search name, symbol..."
                        formControlName="search">
                    <span class="search-icon" aria-hidden="true"></span>
                </div>
            </div>

            <div class="col-md-3">
                <label for="dateRange">Date</label>
                <div class="date-range-input-wrapper">
                    <input
                        id="dateRange"
                        type="text"
                        class="form-control date-range-input"
                        [value]="selectedDateRangeText"
                        placeholder="Select"
                        bsDaterangepicker
                        [bsValue]="filterForm.controls.dateRange.value"
                        [bsConfig]="dateRangeConfig"
                        (bsValueChange)="onDateRangeChange($event)"
                        readonly>
                    <span class="calendar-icon" *ngIf="!selectedDateRangeText" aria-hidden="true"></span>
                    <button
                        *ngIf="selectedDateRangeText"
                        type="button"
                        class="date-clear-btn"
                        (click)="clearDateRange()"
                        aria-label="Clear date">&times;</button>
                </div>
            </div>

            <div class="col-md-2">
                <label for="sector">Sector</label>
                <select 
                  id="sector"
                  class="form-control"
                  formControlName="sector">
                    <option [ngValue]="null">All</option>
                    <option *ngFor="let sector of sectorNames" [ngValue]="sector">{{ sector }}</option>
                </select>
            </div>

            <div class="col-md-2">
                <label for="order">Sort By</label>
                <select 
                  id="order"
                  class="form-control"
                  formControlName="order">
                    <option [ngValue]="'ASC'">A-Z</option>
                    <option [ngValue]="'DESC'">Z-A</option>
                </select>
            </div>
        </div>

    </div>
</div>